module.exports = __webpack_public_path__ + "img/szhx_h.64ef8d5f.png";